import { ArrowUpRight } from 'lucide-react';

const footerLinks = {
  services: [
    { name: 'Immigration Services', href: '/services/immigration' },
    { name: 'Document Preparation', href: '#services' },
    { name: 'Case Management', href: '#services' },
    { name: 'Legal Research', href: '#services' },
    { name: 'Contract Drafting', href: '#services' },
  ],
  company: [
    { name: 'About Us', href: '#about' },
    { name: 'Why Choose Us', href: '#why-us' },
    { name: 'Industries', href: '#industries' },
    { name: 'Our Process', href: '#process' },
    { name: 'Contact', href: '#contact' },
  ],
};

export const Footer = () => {
  const scrollToSection = (href) => {
    if (href === '#') return;
    if (href.startsWith('/')) {
      window.location.href = href;
      return;
    }
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer 
      className="text-white relative overflow-hidden" 
      style={{
        background: 'linear-gradient(135deg, #0a192f 0%, #0d1f38 50%, #0a192f 80%, rgba(217,48,37,0.3) 100%)'
      }}
      data-testid="footer"
    >
      {/* Gradient accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D93025]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-[#D93025]/5 rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-12 mb-16">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-1 font-heading font-bold text-2xl text-white mb-4"
              data-testid="footer-logo"
            >
              Redline<span className="text-[#D93025]">.</span>
            </a>
            <p className="text-sm text-white/60 leading-relaxed mb-6">
              Professional legal support for modern law firms. Precision, 
              efficiency, and excellence in every engagement.
            </p>
            <div className="flex gap-4">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#contact');
                }}
                className="inline-flex items-center gap-2 text-sm font-medium text-white hover:text-[#D93025] transition-colors"
              >
                Get Started
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="font-heading font-medium text-white mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-heading font-medium text-white mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/40">
              &copy; {new Date().getFullYear()} Redline Contracts. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-white/40">
              <span>
                Developed by <span className="text-white/60 font-medium">CoralByte Technologies</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
